import { formatDate } from 'commons/utils/date'
import { formatCnpj } from 'commons/utils/string'

import type {
  KeyAccount,
  KeyAccountAddRequestData,
  KeyAccountApi,
  KeyAccountResponseData,
  KeyAccountResponseDataApi,
  KeyAccountsResponseData,
  KeyAccountsResponseDataApi,
  KeyAccountTracking,
  KeyAccountTrackingApi,
  KeyAccountTrackingResponse,
  KeyAccountTrackingResponseApi,
} from './types'

export const toKeyAccount = (keyAccountApi: KeyAccountApi): KeyAccount => {
  return {
    cnpj: keyAccountApi.cnpj,
    cnpjFormatted: formatCnpj(keyAccountApi.cnpj),
    id: keyAccountApi.codigo,
    name: keyAccountApi.nome,
  }
}

export const toKeyAccountResponseData = (
  response: KeyAccountResponseDataApi,
): KeyAccountResponseData => {
  const { data } = response

  return {
    data: toKeyAccount(data),
  }
}

export const toKeyAccountsResponseData = (
  response: KeyAccountsResponseDataApi,
): KeyAccountsResponseData => {
  const { data } = response

  const keyAccounts = data.map((keyAccount) => {
    return toKeyAccount(keyAccount)
  })

  return {
    data: keyAccounts,
  }
}

export const toKeyAccountAddRequestData = (id: string): KeyAccountAddRequestData => {
  return {
    codigo: id,
  }
}

export const toKeyAccountTracking = (keyAccountApi: KeyAccountTrackingApi): KeyAccountTracking => {
  return {
    action: keyAccountApi.acao,
    cnpj: keyAccountApi.cnpj,
    cnpjFormatted: formatCnpj(keyAccountApi.cnpj),
    date: keyAccountApi.data,
    dateFormatted: formatDate(keyAccountApi.data, 'DD/MM/YYYY'),
    id: keyAccountApi.codigo,
    idSapCustomer: keyAccountApi.codigoSap,
    name: keyAccountApi.nomeCliente,
    timeFormatted: formatDate(keyAccountApi.data, 'HH:mm'),
    user: keyAccountApi.usuario,
  }
}

export const toKeyAccountTrackingResponse = (
  response: KeyAccountTrackingResponseApi,
): KeyAccountTrackingResponse => {
  const { data, pagination } = response

  const keyAccountsTracking = data.map((keyAccountTrackingApi) => {
    return toKeyAccountTracking(keyAccountTrackingApi)
  })

  return {
    data: keyAccountsTracking,
    pagination,
  }
}
